<template>
  <div class="fre-input">
    <span>{{label}}</span>
    <div class="input-content">
      <img src="@/assets/images/cdn/icon_time.png" alt="">
      <input
       :value="frontVal"
       class="first-input"
       @input="firstChange"
        />
      <div class="input-line">/</div>
      <input
       :value="endVal"
       class="secord-input"
       @input="secordChange"
        />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    frontVal: String,
    endVal: String,
    label: String,
  },
  methods: {
    firstChange(e) {
      this.$emit('input1', e.target.value);
    },
    secordChange(e) {
      this.$emit('input2', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.fre-input {
  margin-top: 35px;
  padding-bottom: 31px;
  border-bottom: 1px solid #D7DBEC;
  span {
    font-family: PingFangSC-Semibold;
    font-size: 14px;
    color: #5A607F;
  }
  .input-content {
    display: flex;
    align-items: center;
    margin-top: 18px;
    img {
      margin-right: 8px;
    }
    input {
      border: 1px solid #D9E1EC;
      border-radius: 4px;
      height: 36px;
      padding-left: 8px;
    }
    .first-input {
      width: 140px;
    }
    .secord-input {
      width: 80px;
    }
    .input-line {
      width: 34px;
      height: 34px;
      background: #1E5EFF;
      border-radius: 4px;
      line-height: 34px;
      text-align: center;
      color: white;
    }
  }
}
</style>
